import { gql } from "@apollo/client";

export const getMillLiveDowntimeReportSubscription = gql`
    subscription getMillLiveDowntimeReportSubscription(
        $millId: Int!
        $productionLinesShiftsWhere: production_line_shift_bool_exp
    ) {
        machine_center(
            where: { production_line: { mill_id: { _eq: $millId } }, disabled_at: { _is_null: true } }
            order_by: { created_at: asc }
        ) {
            name
            machine_center_id
            order
            short_name
            downtime_trigger_threshold
            is_bottleneck
            production_line {
                production_line_id
                name
                production_line_shifts(where: $productionLinesShiftsWhere) {
                    shift {
                        shift_id
                        name
                        shift_historic {
                            start_time
                            end_time
                            effective_at
                            shift_days {
                                is_enabled
                                day {
                                    day_id
                                    name
                                    default_day_translations {
                                        default_day_translation_id
                                        language {
                                            language_id
                                            name
                                        }
                                        translated_name
                                    }
                                }
                            }
                        }
                    }
                }
                mill {
                    maximum_overtime
                    mill_data {
                        timezone
                    }
                }
            }
            event_reports(where: { end_date: { _is_null: true } }, limit: 1, order_by: { start_date: desc }) {
                start_date
                measure_metric_id
                failure_code {
                    name
                    code
                    default_failure_code_translations {
                        failure_code_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
                failure_type {
                    name
                    code
                    default_failure_type_translations {
                        failure_type_id
                        language {
                            language_id
                            name
                        }
                        translated_name
                    }
                }
                functional_location {
                    translation {
                        id
                        translation_names {
                            name
                            language_id
                        }
                    }
                }
                area {
                    translation {
                        id
                        translation_names {
                            name
                            language_id
                        }
                    }
                }
            }
        }
    }
`;
